<template>
  <textarea
    v-model="state"
    :class="$style.BaseInput"
    :style="{
      height: lines + 3 + 'rem'
    }"
  />
</template>
<script>
import AsyncVModel from '../mixins/async-vmodel';

export default {
  name: 'BaseTextarea',
  mixins: [AsyncVModel],
  props: {
    value: {
      type: [String, Number],
      default: null,
      required: false
    }
  },
  computed: {
    lines() {
      let lines = 0;
      const lineBreaks = this.state.match(/[\n\r]/g);
      if (Array.isArray(lineBreaks)) {
        lines = lineBreaks.length;
      }
      return lines;
    }
  }
};
</script>
<style lang="scss" src="../scss/components/input/TextInput.scss" module></style>
